import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="table-to-csv"
export default class extends Controller {
  static targets = ['button', 'table'];
  static values = {
    accountName: String,
    fileType: {type: String, default: 'schema'}
  }

  getCsvData() {
    let csvData = [];
    let rows = this.tableTarget.rows;
    
    for (let i = 0; i < rows.length; i++) {
      let row = [], cols = rows[i].querySelectorAll("td, th");
      for (let j = 0; j < cols.length; j++) {
        let content = cols[j].innerText.split("\n").at(0).trim();
        row.push(`"${content}"`); 
      }
        
      csvData.push(row.join(","));        
    }
    return csvData.join("\n"); 
  }

  downloadData () {
    if (this.buttonTarget.disabled) {
      return;
    }

    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    
    let csvData = this.getCsvData()

    let blob = new Blob([csvData], {type: "text/csv"});
    let url = window.URL.createObjectURL(blob);
    
    a.href = url;
    a.download = `${this.accountNameValue}-${this.fileTypeValue}-${new Date().getTime()}.csv`;
    a.click();
    
    window.URL.revokeObjectURL(url);
  }
}
